import { ReactNode, useState } from "react";

export type SubmitStateType = {
  submitted: boolean;
  loading: boolean;
  error: string | false;
  buttonChild: ReactNode;
  init: (buttonChild?: ReactNode) => void;
  fetchFailed: (error: string, buttonChild: ReactNode) => void;
  fetchSuccess: (buttonChild: ReactNode, loading?: boolean) => void;
};
export function useSubmitState({
  initLoading = false,
  initError = false,
  initButtonChild = "Abschicken",
}: {
  initLoading?: boolean;
  initError?: string | false;
  initButtonChild?: ReactNode;
}): SubmitStateType {
  const [submitted, setSubmitted] = useState<boolean>(initLoading);
  const [loading, setLoading] = useState<boolean>(initLoading);
  const [error, setError] = useState<string | false>(initError);
  const [buttonChild, setButtonChild] = useState<ReactNode>(initButtonChild);

  function init(buttonChild: ReactNode = "Lädt...") {
    setButtonChild(buttonChild);
    setLoading(true);
  }
  function fetchFailed(error: string, buttonChild: ReactNode) {
    setError(error);
    setSubmitted(false);
    setLoading(false);
    setButtonChild(buttonChild);
  }

  function fetchSuccess(buttonChild: ReactNode, loading: boolean = false) {
    setLoading(loading);
    setButtonChild(buttonChild);
    setSubmitted(true);
  }
  return {
    submitted: submitted,
    loading: loading,
    error: error,
    buttonChild: buttonChild,
    init: init,
    fetchFailed: fetchFailed,
    fetchSuccess: fetchSuccess,
  };
}
